import { useState } from 'react';
import { Modal, ModalBody, Spinner } from 'reactstrap';
import Button from '../ui/Button';

interface PolicyModalProps {
  onAgree?: () => void;
  isOpen?: boolean;
  isLoading?: boolean;
}

const PolicyModal = ({ onAgree, isOpen, isLoading }: PolicyModalProps) => {
  const [checked, setChecked] = useState(false);

  return (
    <Modal isOpen={isOpen} centered size="lg" scrollable>
      <ModalBody>
        <div className="modal_scroll">
          <h2 className="fw-semibold text-center underline mb-4">
            Office Time & Discipline Policies
          </h2>

          <h4 className="fw-semibold mb-3">Office Time Discipline</h4>

          <ol className="ps-3 policy-list">
            <li className="mb-2">
              The office check-in time is <strong>9:45 AM.</strong>
            </li>
            <li className="mb-2">
              The final check-in time is <strong>10:05 AM.</strong> Regular
              delays beyond this limit are not acceptable (maximum four times
              per month with a valid reason). Any delayed time must be
              compensated; otherwise, it will result in salary deductions or may
              impact performance evaluations for half yearly salary increments.
            </li>
            <li className="mb-2">
              Official working hours are from{' '}
              <strong>9:45 AM to 6:15 PM,</strong> with a 20-minute flexibility
              window and a 45-minute lunch break.
            </li>
            <li className="mb-2">
              The total working hours per day are approximately{' '}
              <strong>7 hours and 30 minutes.</strong>
            </li>
            <li className="mb-2">
              Weekly working hours must total{' '}
              <strong>at least 45 effective hours.</strong> This should have to
              be calculated in terms of the tasks assigned to that person and
              completion of that task, Team lead or senior developers will be
              supporting this on a regular basis.
            </li>
            <li className="mb-2">
              Weekly one day delay is accepted with proper reason and Prior
              information (before 10:05).
            </li>
            <li className="mb-2">
              Team leads can allow employees to leave early due to valid
              reasons. Accountability of work will be on Team leads.
            </li>
            <li className="mb-2">
              If Employees are late for more than{' '}
              <strong>four days per month</strong> all delayed days will be
              eligible for deduction.
            </li>
            <li className="mb-2">
              Duration of Delay will also affect the percentage of deduction.
              Salary Deduction will increase based on the number of days
              delayed.
            </li>
          </ol>

          <table className="table table-bordered border-dark w-75 mx-auto align-middle text-center my-3">
            <thead>
              <tr>
                <th className="border-dark fw-semibold">No of Days</th>
                <th className="border-dark fw-semibold">Deduction</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border-dark">5</td>
                <td className="border-dark">50% (Half day salary deduction)</td>
              </tr>
              <tr>
                <td className="border-dark">6–10</td>
                <td className="border-dark">
                  75% (Three quarter day salary deduction)
                </td>
              </tr>
              <tr>
                <td className="border-dark">&gt;10</td>
                <td className="border-dark">
                  100% (Full day salary deduction)
                </td>
              </tr>
            </tbody>
          </table>

          <ol className="ps-3 policy-list" start={10}>
            <li className="mb-2">
              If an employee takes two leaves per month (16 hours in total),
              those hours will be deducted from the required working hours, in
              case we have to adjust that time because of lack of effective
              working hours. Approval from management is required for this
              adjustment.
            </li>
          </ol>

          <label className="d-flex align-items-center justify-content-start gap-1 mb-3 text-muted terms_text">
            <input
              type="checkbox"
              checked={checked}
              onChange={() => setChecked(!checked)}
            />
            I agree to the terms and conditions
          </label>

          <div className="d-flex justify-content-end">
            <Button
              className={`btn btn-primary text-white ${
                checked ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-400'
              }`}
              onClick={onAgree}
              disabled={!checked}
            >
              {isLoading ? <Spinner /> : 'Agree & Continue'}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PolicyModal;
